export default __webpack_public_path__ + "static/media/our-services-home-care-physical-disabilities-care-01.4f5e215d.jpg";